import { useCallback, useMemo } from 'react';

import ROUTES from '@/common/routes';
import { LockboxStatus, LockboxType } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const useContinueInAdminPortal = () => {
  const { editableLockbox, originalLockbox } = useLockboxDetailsStore();

  const isCombineHSA = editableLockbox?.lockboxType === LockboxType.COMBINE_HSA;

  const isVisible = useMemo(
    () =>
      (editableLockbox?.lockboxType === LockboxType.EXCESS_CONTRIBUTION ||
        editableLockbox?.lockboxType === LockboxType.COMBINE_HSA) &&
      !!editableLockbox?.employeeId &&
      originalLockbox?.lockboxStatus !== LockboxStatus.CANCELED &&
      originalLockbox?.lockboxStatus !== LockboxStatus.PROCESSED_MANUALLY,
    [editableLockbox, originalLockbox]
  );

  const matchedEmployee = useMemo(() => {
    const fromMatches = originalLockbox?.matchEmployees?.find(
      (emp) => emp.employeeId === editableLockbox?.employeeId
    );
    if (fromMatches) return fromMatches;

    if (editableLockbox?.employeeId) {
      return {
        employeeId: editableLockbox.employeeId,
        employeeName: editableLockbox.employeeName,
        ssn: editableLockbox.employeeSsn,
      };
    }

    return undefined;
  }, [originalLockbox?.matchEmployees, editableLockbox?.employeeId, editableLockbox?.employeeName, editableLockbox?.employeeSsn]);

  const handleGoToAdminPortal = useCallback(() => {
    const employeeId = editableLockbox?.employeeId;
    const accountId = editableLockbox?.accountId;

    if (!employeeId) return;

    if (!accountId) {
      const url = ROUTES.EMPLOYEE_VIEW(employeeId);
      window.open(url, '_blank');
      return;
    };

    const action = editableLockbox?.lockboxType === LockboxType.EXCESS_CONTRIBUTION
      ? LockboxType.EXCESS_CONTRIBUTION
      : editableLockbox?.lockboxType === LockboxType.COMBINE_HSA
        ? LockboxType.COMBINE_HSA
        : undefined;

    const url = action
      ? `${ROUTES.ENROLLMENT_DETAILS(employeeId, accountId)}?action=${action}`
      : ROUTES.ENROLLMENT_DETAILS(employeeId, accountId);

    window.open(url, '_blank');
  }, [editableLockbox]);

  return {
    isVisible,
    isCombineHSA,
    matchedEmployee,
    handleGoToAdminPortal,
  };
};

export default useContinueInAdminPortal;
